import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import {
  Button, message, Icon, Popconfirm,
} from 'antd';
import moment from 'moment';
import PageHeader from '../../components/PageHeader';
import Container from '../../components/Container';
import StatusTaggingForm from '../../components/StatusTaggingForm';
import { fetchTransmittalTrackingNumber, submitTransmittal } from '../ducks';
import { remove } from 'lodash';

export class MerchantPickupRejected extends Component {
  constructor(props) {
    super(props);
    this.state = {
      trackingNumberRows: [],
      errors: [],
    };

    this.validatePackage = this.validatePackage.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.confirmRemove = this.confirmRemove.bind(this);
    let atwCacheString = window.localStorage.getItem('trej_cache');
    let atwCache = [];
    if(atwCacheString){
      atwCache = JSON.parse(atwCacheString);
    }
    for(let i = 0; i < atwCache.length; i++){
      let tn = atwCache[i];
      this.validatePackage({comment:tn.comment,trackingNumber:tn.tn});
    }
  }

  submitForm(values) {
    const { trackingNumberRows } = this.state;
    const { doSubmitTransmittal, history } = this.props;
    const packageList = [];

    // eslint-disable-next-line no-unused-vars
    trackingNumberRows.forEach((item, key) => {
      packageList.push(item.tracking_number);
    });

    const payload = {
      packages: packageList,
      // from: moment(values.dateFrom).format('YYYY-MM-DD'),
      // to: moment(values.dateTo).format('YYYY-MM-DD'),
      from: values.dateFrom,
      to: values.dateTo,
      remarks: values.comment,
      type: 'rejected',
      via: values.mode,
    };

    doSubmitTransmittal(payload)
      .then((action) => {
        this.setState({
          trackingNumberRows: [],
        });
        let ar = [];
        window.localStorage.setItem('trej_cache',JSON.stringify(ar));
        history.push(
          `/merchant-pickup/transmittal/${action.payload.data.transmittal_id}`,
        );
      })
      .catch(() => {
        message.error('Something went wrong, please try again later.');
      });
  }
removeTnCache(tn){
    let atwCacheString = window.localStorage.getItem('trej_cache');
    let atwCache = [];
    if(atwCacheString){
      atwCache = JSON.parse(atwCacheString);
    }
    const index = atwCache.findIndex(
      item => item.tn === tn
    );
    if (index !== -1) {
        atwCache.splice(index, 1);
        window.localStorage.setItem('trej_cache',JSON.stringify(atwCache));
    }
  }
  getTnCacheArray(tn){
    let atwCacheString = window.localStorage.getItem('trej_cache');
    let atwCache = [];
    if(atwCacheString){
      atwCache = JSON.parse(atwCacheString);
    }
    return atwCache;
  }
  addTnCache(tn,comment){
    tn = tn.toUpperCase();
    let atwCacheString = window.localStorage.getItem('trej_cache');
    let atwCache = [];
    if(atwCacheString){
      atwCache = JSON.parse(atwCacheString);
    }
    const exists = atwCache.some(item => item.tn === tn);
    if(exists){
      return;
    }
    atwCache.push({tn:tn,comment:comment});
    console.log(JSON.stringify(atwCache));
    window.localStorage.setItem('trej_cache',JSON.stringify(atwCache));
  }
  validatePackage(values) {
    const { trackingNumberRows } = this.state;
    const { doFetchTransmittalTrackingNumber } = this.props;

    const splitTrackingNumber = values.trackingNumber
      ? values.trackingNumber.split('\n')
      : '';
    const filteredTrackingNumber = splitTrackingNumber.filter(
      (item, key) => splitTrackingNumber.indexOf(item) >= key && item !== '',
    );
    // eslint-disable-next-line no-unused-vars
    filteredTrackingNumber.forEach((item, key) => {
      this.addTnCache(item,values.comment);
      const exists = trackingNumberRows.filter(
        tn => tn.tracking_number === item,
      );

      if (exists.length > 0) {
        message.error(`Tracking number ${item} is already entered.`);
        this.setState(prevState => ({
          errors: [
            ...prevState.errors,
            {
              tracking_number: item,
              message: 'Tracking number is already entered.',
            },
          ],
        }));
      } else {
        doFetchTransmittalTrackingNumber('rejected', item)
          .then((action) => {
            this.setState(prevState => ({
              trackingNumberRows: [
                ...prevState.trackingNumberRows,
                {
                  tracking_number: action.payload.data.tracking_number,
                  address_city: action.payload.data.address_city,
                  consignee_address: action.payload.data.consignee_address,
                  remarks: values.comment,
                  shipment_provider: action.payload.data.shipment_provider,
                },
              ],
            }));
            message.success('Successfully added tracking number!.');
          })
          .catch((action) => {
            let errorMessage;
            this.removeTnCache(item);
            if (action.error.response.status === 400) {
              errorMessage = action.error.response.data.message;
              this.setState(prevState => ({
                errors: [
                  ...prevState.errors,
                  {
                    tracking_number: item,
                    message: action.error.response.data.message,
                  },
                ],
              }));
            } else {
              errorMessage = 'Something went wrong, please try again later.';
            }
            message.error(errorMessage, 3);
          });
      }
    });
  }

  confirmRemove(trackingNumber) {
    const { trackingNumberRows } = this.state;
    this.removeTnCache(trackingNumber);
    const filteredTrackingNumber = trackingNumberRows.filter(
      data => data.tracking_number !== trackingNumber,
    );

    this.setState({
      trackingNumberRows: filteredTrackingNumber,
    });

    message.success('Successfully removed tracking number!');
  }

  render() {
    const { trackingNumberRows, errors } = this.state;
    const breadCrumbs = [
      {
        breadcrumbName: 'Packages',
      },
      {
        breadcrumbName: 'Transmittal Rejected',
      },
      {
        breadcrumbName: 'Rejected',
      },
    ];

    const trackingNumberRowColumns = [
      {
        Header: 'Tracking Number',
        accessor: 'tracking_number',
      },
      {
        Header: 'City',
        accessor: 'address_city',
      },
      {
        Header: 'Consignee Address',
        accessor: 'consignee_address',
      },
      {
        Header: 'Remarks',
        accessor: 'remarks',
      },
      {
        Header: 'Shipment Provider',
        accessor: 'shipment_provider',
      },
      {
        Header: 'Options',
        sortable: false,
        filterable: false,
        Cell: data => (
          <React.Fragment>
            <Popconfirm
              placement="leftBottom"
              title={`Are you sure you want to delete ${data.row.tracking_number} from the list?`}
              okText="Yes"
              onConfirm={() => this.confirmRemove(data.row.tracking_number)}
              cancelText="No"
            >
              <Button type="link" block>
                <Icon viewBox="0 0 1024 1024">
                  <FontAwesomeIcon icon={faTrash} fixedWidth />
                </Icon>
                Remove
              </Button>
            </Popconfirm>
          </React.Fragment>
        ),
      },
    ];

    return (
      <div className="MerchantPickupRejected">
        <PageHeader title="Transmittal" routes={breadCrumbs} />
        <Container>
          <StatusTaggingForm
            hasDatePicker={false}
            validateHandler={this.validatePackage}
            submitHandler={this.submitForm}
            trackingNumberList={trackingNumberRows}
            trackingNumberListColumns={trackingNumberRowColumns}
            errorList={errors}
            hasTransmittalMode
          />
        </Container>
      </div>
    );
  }
}

MerchantPickupRejected.propTypes = {
  history: PropTypes.oneOfType([PropTypes.object]).isRequired,
  doFetchTransmittalTrackingNumber: PropTypes.func.isRequired,
  doSubmitTransmittal: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  doFetchTransmittalTrackingNumber: fetchTransmittalTrackingNumber,
  doSubmitTransmittal: submitTransmittal,
};

export default connect(null, mapDispatchToProps)(MerchantPickupRejected);
